import type { ContestType } from '@betterpool/api-types/contests-service';

import type { FullContestPlayerSurvivor } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import type { ContestSlate } from '~/domains/games/interfaces/contest.slates.interface';

import parseSlateBase from '../../common/context/SlatesContext/parseSlates/parseBaseSlate';

type SlateWithStateAndSettingsPlayerSurvivor = {
  id: string;
  contestType: ContestType.PLAYER_SURVIVOR;
  slate: ContestSlate & { isUpcoming?: boolean };
  settings: {
    expectedPicksCount: number;
  };
  state: {
    isAfterPickDeadline?: boolean;
    picksLabel?: string;
  };
};

const getUpcomingSlate = (
  slates: ContestSlate[],
  slate: ContestSlate,
  contest: FullContestPlayerSurvivor
) => {
  const lastSlate = slates[slates.length - 1];
  const isLast = lastSlate.id === slate.id;

  return isLast && (contest?.slateCount ?? 0) > slates.length && !contest?.final_slate_id;
};

const parsePlayerSurvivorSlates = (
  contest: FullContestPlayerSurvivor,
  slates: ContestSlate[]
): SlateWithStateAndSettingsPlayerSurvivor[] =>
  slates.map((slate, index) => {
    const baseSlate = parseSlateBase(contest, slate, index);

    return {
      ...baseSlate,
      contestType: contest.contest_type,
      slate: {
        ...baseSlate.slate,
        isUpcoming: getUpcomingSlate(slates, slate, contest),
      },
    } satisfies SlateWithStateAndSettingsPlayerSurvivor;
  });

export default parsePlayerSurvivorSlates;

export type { SlateWithStateAndSettingsPlayerSurvivor };
